import { render, staticRenderFns } from "./LeaderboardSlide.vue?vue&type=template&id=085d02c0&scoped=true&"
import script from "./LeaderboardSlide.vue?vue&type=script&lang=js&"
export * from "./LeaderboardSlide.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardSlide.vue?vue&type=style&index=0&id=085d02c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d02c0",
  null
  
)

export default component.exports